export const PLANNER_VIEWS = {
  OVERVIEW: 'overview',
  TIMELINE: 'timeline',
  TABLE: 'table',
} as const;

export type PlannerView = (typeof PLANNER_VIEWS)[keyof typeof PLANNER_VIEWS];

export const DEFAULT_PLANNER_VIEW = PLANNER_VIEWS.OVERVIEW;

export const isPlannerView = (value: string): value is PlannerView =>
  Object.values(PLANNER_VIEWS).some((view) => view === value);
